import React, { useEffect } from 'react'
import NaveBar from '../composant/NaveHero/NaveBar'
import Footer from '../composant/Footer'
import TeamSection2 from '../composant/TeamSection2'
import MainContainerAdhesion2 from '../composant/MainContainerAdhesion2'



const Teams = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <div>
       <NaveBar />
    
       <TeamSection2 />
       <MainContainerAdhesion2 />


       <Footer />
    </div>
  )
}

export default Teams
